import { useContext, useEffect, useState } from "react";
import { Accordion, Button, Col, Row, Spinner, Stack } from "react-bootstrap";
import { AlertContext } from "../alert/AlertContext";
import ReportService from "../../services/ReportService";
import CancelableSelect from "../cancelableSelect/CancelableSelect";
import FareZoneService from "../../services/FareZoneService";
import { ErrorMessage } from "../../@ui/ErrorMessage";

export const NaptanWithinAZoneReportAccordian = () => { 
    const [isLoading, setIsLoading] = useState(false);
    const alertContext = useContext(AlertContext);
    const [fareZoneList, setFareZoneList] = useState<
    { value: string; label: string }[]
  >([]);

  const [adminAreaSelection, setAdminAreaSelection] = useState<{ value: string; label: string }>();
  const [invalid, setInvalid] = useState(false);

  useEffect(() => {
    fareZoneService.getAll(true).then((r) => {
        const options = r.map((fareZone) => ({
          value: fareZone.id,
          label: fareZone.name,
        }));
        setFareZoneList(options);
      });
} , []);


    if (!alertContext) return <></>;

    const fareZoneService = new FareZoneService(alertContext.showAlert);
    const reportService = new ReportService(alertContext.showAlert);

    const getReport = () => {
    if (!adminAreaSelection) {
        setInvalid(true);
        return;
    } 
    setIsLoading(true);
    reportService.getNaptanWithinAZoneReport(adminAreaSelection.value).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response]));
  
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute(
          "download",
          `naptan_report_${adminAreaSelection.label.toLowerCase()}_${new Date().toISOString()}.csv`
        );
        document.body.appendChild(link);
        link.click();
  
        link.parentNode?.removeChild(link);
        window.URL.revokeObjectURL(url);
        setIsLoading(false);
    })
};
    const setSelected = (e: string | undefined) => {
        if(!e) return;
        setInvalid(false);
        setAdminAreaSelection(fareZoneList.find((fz) => fz.value === e));
    };


    return (
        <>
          <Accordion.Item eventKey="naptanWithinAZoneReportAccordian">
            <Accordion.Header>Naptan Report Within a zone</Accordion.Header>
            <Accordion.Body>
              <p>
                This report shows all of the naptan stops for the selected fare zone.
              </p>

            <Stack gap={3}>
            <Row>
                <Col md="6" sm="12"> 
                <CancelableSelect
            options={fareZoneList}
            placeHolder={"Select a zone"}
            onSelect={(e) => setSelected(e)}
            value={""}
            disabled={fareZoneList.length === 0}
          />
                </Col>
              </Row>
              <Row>
                <Col md="6" sm="12">
                     <Button
                variant="primary"
                onClick={getReport}
                disabled={isLoading}
              >
                {!isLoading && <div>Download</div>}
                {isLoading && (
                  <>
                    Downloading...{" "}
                    <Spinner animation="border" role="status" size="sm" />
                  </>
                )}
              </Button>
                    </Col>
              </Row>
              {
                invalid && <ErrorMessage>Please select a zone</ErrorMessage>
              }
              
            </Stack>            
            </Accordion.Body>
          </Accordion.Item>
        </>
      );
};